<template>
  <login-container>
    <div class="text--center">
      <h1 class="font--28px text--black pb--18px">회원탈퇴가 완료되었습니다</h1>
      <p class="text--gray darken--2">그동안 서비스를 이용해주셔서 감사합니다.
        <br>보다 나은 서비스로 다시 찾아뵙겠습니다.
      </p>
    </div>

    <div class="pt--48px pb--24px">
      <form-button
        @click="$router.push({name: 'home'})"
        label="HOME"
        class="btn btn--block btn--xxxl black text--white"
      ></form-button>
    </div>
  </login-container>
</template>

<script>
export default {
  components: {
    LoginContainer: () => import('@/component/container/LoginContainer'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
